import Lookup from 'src/componentes/select2';

const StatusRiscoPontoControle = (props) => {
  return (
    <Lookup
      labelKey="descricao"
      minHeight={'38px'}
      valueKey="id"
      url="/StatusRiscoPontoControleLookup"
      {...props}
    />
  );
};

export default StatusRiscoPontoControle;
